import * as Actions from 'store/actions/app/commissions.actions'

const initialState = {
  loading_commissions: false,
  commissions: [],
  total_commissions: 0,

  paying_commission: false,
  payed_commission: false,

  loading_commission_detail: false,
  commission_detail: [],

  commission_report: null,
  loading_commission_report: false,
  downloading_commission_report: false,
}

const commissionsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_COMMISSIONS: {
      return {
        ...state,
        loading_commissions: action.payload.loading ?? state.loading_commissions,
        commissions: action.payload.items ?? state.commissions,
        total_commissions: action.payload.total ?? state.total_commissions,
      }
    }
    case Actions.PAY_COMMISSION: {
      return {
        ...state,
        paying_commission: action.payload.saving ?? state.paying_commission,
        payed_commission: action.payload.saved ?? false,
      }
    }
    case Actions.GET_COMMISSION_DETAIL: {
      return {
        ...state,
        loading_commission_detail: action.payload.loading ?? state.loading_commission_detail,
        commission_detail: action.payload.data ?? state.commission_detail,
      }
    }
    case Actions.GET_COMMISSIONS_REPORT: {
      return {
        ...state,
        loading_commission_report: action.payload.loading ?? state.loading_commission_report,
        commission_report: action.payload.data ?? state.commission_report,
      }
    }
    case Actions.DOWNLOADING_COMMISSION_REPORT: {
      return {
        ...state,
        downloading_commission_report: action.payload ?? state.downloading_commission_report,
      }
    }
    default: {
      return state
    }
  }
}

export default commissionsReducer
